import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "shell" }
const _hoisted_2 = { class: "search-container" }
const _hoisted_3 = { class: "search-form-item" }
const _hoisted_4 = { class: "form-label" }
const _hoisted_5 = { class: "search-form-item" }
const _hoisted_6 = { class: "form-label" }
const _hoisted_7 = {
  key: 1,
  class: "search-form-item"
}
const _hoisted_8 = { class: "form-label" }
const _hoisted_9 = { class: "search-form-item" }
const _hoisted_10 = { class: "form-label" }
const _hoisted_11 = { class: "search-form-item" }
const _hoisted_12 = /*#__PURE__*/_createVNode("span", { class: "el-icon-search" }, null, -1)
const _hoisted_13 = { class: "name-slot" }
const _hoisted_14 = { style: {"margin-right":"8px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_property_bread_crumb = _resolveComponent("property-bread-crumb")
  const _component_secondary_nav = _resolveComponent("secondary-nav")
  const _component_cus_option = _resolveComponent("cus-option")
  const _component_cus_select = _resolveComponent("cus-select")
  const _component_el_input = _resolveComponent("el-input")
  const _component_cus_button = _resolveComponent("cus-button")
  const _component_tip = _resolveComponent("tip")
  const _component_list_pagination = _resolveComponent("list-pagination")
  const _component_library_edit_dialog = _resolveComponent("library-edit-dialog")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_property_bread_crumb, { headers: _ctx.breadCrumb }, null, 8, ["headers"]),
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_secondary_nav, {
        navs: _ctx.secondMenus,
        active: _ctx.activeNavItem,
        onChoose: _ctx.changePath
      }, null, 8, ["navs", "active", "onChoose"]),
      _createVNode("div", _hoisted_2, [
        (_ctx.projectType=='community')
          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
              _createVNode("div", _hoisted_3, [
                _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$wordList.DeviceDetailDetailUnitName), 1),
                _createVNode(_component_cus_select, {
                  modelValue: _ctx.listRequestData.param.Building,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.listRequestData.param.Building = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_cus_option, {
                      label: _ctx.$wordList.SelectAll,
                      value: "all"
                    }, null, 8, ["label"]),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.buildOptions, (item) => {
                      return (_openBlock(), _createBlock(_component_cus_option, {
                        key: item.key,
                        value: item.key,
                        label: item.value
                      }, null, 8, ["value", "label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createVNode("div", _hoisted_5, [
                _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$wordList.RDeviceSearchLabelRoomName), 1),
                _createVNode(_component_cus_select, {
                  modelValue: _ctx.listRequestData.param.Apt,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.listRequestData.param.Apt = $event)),
                  filter: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_cus_option, {
                      label: _ctx.$wordList.SelectAll,
                      value: "all"
                    }, null, 8, ["label"]),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.aptOptions, (item) => {
                      return (_openBlock(), _createBlock(_component_cus_option, {
                        key: item.key,
                        value: item.key,
                        label: item.value
                      }, null, 8, ["value", "label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.projectType=='office')
          ? (_openBlock(), _createBlock("div", _hoisted_7, [
              _createVNode("label", _hoisted_8, _toDisplayString(_ctx.$wordList.ProperAllTextDepartment), 1),
              _createVNode(_component_cus_select, {
                modelValue: _ctx.listRequestData.param.Building,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.listRequestData.param.Building = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_cus_option, {
                    label: _ctx.$wordList.SelectAll,
                    value: "all"
                  }, null, 8, ["label"]),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.buildOptions, (item) => {
                    return (_openBlock(), _createBlock(_component_cus_option, {
                      key: item.key,
                      value: item.key,
                      label: item.value
                    }, null, 8, ["value", "label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_9, [
          _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$wordList.ProperAllTextIdentity), 1),
          _createVNode(_component_cus_select, {
            modelValue: _ctx.listRequestData.param.Type,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.listRequestData.param.Type = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_cus_option, {
                label: _ctx.$wordList.SelectAll,
                value: "all"
              }, null, 8, ["label"]),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.identity, (item) => {
                return (_openBlock(), _createBlock(_component_cus_option, {
                  key: item.ID,
                  value: item.ID,
                  label: item.Label
                }, null, 8, ["value", "label"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createVNode("div", _hoisted_11, [
          _createVNode(_component_el_input, {
            modelValue: _ctx.listRequestData.param.searchValue,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.listRequestData.param.searchValue = $event))
          }, {
            prepend: _withCtx(() => [
              _createVNode(_component_cus_select, {
                modelValue: _ctx.listRequestData.param.searchKey,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.listRequestData.param.searchKey = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.searchKeyList, (item) => {
                    return (_openBlock(), _createBlock(_component_cus_option, {
                      key: item,
                      value: item.name,
                      label: item.label
                    }, null, 8, ["value", "label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createVNode(_component_cus_button, { onClick: _ctx.searchList }, {
          default: _withCtx(() => [
            _hoisted_12,
            _createTextVNode(" " + _toDisplayString(_ctx.$wordList.LogInHtmlSearch), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createVNode(_component_list_pagination, {
        headers: _ctx.headers,
        requestData: _ctx.listRequestData,
        update: _ctx.updateToList,
        showDefaultAction: _ctx.defaultAction,
        deleteUrl: _ctx.deleteUrl,
        action: _ctx.cardAction,
        saveParamInPath: _ctx.saveParamInPath,
        isSaveParamInPathInRow: true,
        disableCheckCondition: _ctx.disableCheckCondition,
        onEdit: _ctx.edit
      }, {
        NameSlot: _withCtx((data) => [
          _createVNode("div", _hoisted_13, [
            _createVNode("label", _hoisted_14, _toDisplayString(data.scope.Name?data.scope.Name:'--'), 1),
            (data.scope.Type === _ctx.resident)
              ? (_openBlock(), _createBlock(_component_tip, {
                  key: 0,
                  color: "#676767"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextResident), 1)
                  ]),
                  _: 1
                }))
              : (data.scope.Type === _ctx.delivery)
                ? (_openBlock(), _createBlock(_component_tip, {
                    key: 1,
                    color: "#676767"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextDelivery), 1)
                    ]),
                    _: 1
                  }))
                : (data.scope.Type === _ctx.staff)
                  ? (_openBlock(), _createBlock(_component_tip, {
                      key: 2,
                      color: "#676767"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$wordList.OfficeStaff), 1)
                      ]),
                      _: 1
                    }))
                  : (Number(data.scope.Type) === _ctx.account.personnelRole)
                    ? (_openBlock(), _createBlock(_component_tip, {
                        key: 3,
                        color: "#676767"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$wordList.BasicUser), 1)
                        ]),
                        _: 1
                      }))
                    : (Number(data.scope.Type) === _ctx.account.staffRole)
                      ? (_openBlock(), _createBlock(_component_tip, {
                          key: 4,
                          color: "#676767"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$wordList.AdvancedUser), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["headers", "requestData", "update", "showDefaultAction", "deleteUrl", "action", "saveParamInPath", "disableCheckCondition", "onEdit"]),
      (_ctx.isShowLibraryEditDialog)
        ? (_openBlock(), _createBlock(_component_library_edit_dialog, {
            key: 0,
            "init-form": _ctx.initForm,
            "pin-or-card": _ctx.activeNavItem,
            onSuccess: _cache[7] || (_cache[7] = ($event: any) => (_ctx.updateToList++)),
            onClose: _cache[8] || (_cache[8] = ($event: any) => (_ctx.isShowLibraryEditDialog=false))
          }, null, 8, ["init-form", "pin-or-card"]))
        : _createCommentVNode("", true)
    ])
  ]))
}